import React from "react";
import moment from 'moment';

export const DateDynamicColumnFormatter = (cellContent, row, rowIndex, { dIndexName, formate, dIndexName2, checkColum, checkValue  }) => (
    //   console.log(dIndexName, 'dIndexName', row[dIndexName], row['approvedAt'])
    (checkColum && checkValue ) ? 
    (row[checkColum] !== checkValue) ? "-" :  
    (dIndexName && row[dIndexName]) ? 
        formate ? dIndexName2 ?
        row[dIndexName][dIndexName2] ?
            moment(row[dIndexName][dIndexName2]).format(formate) : 
            "-" :
            moment(row[dIndexName]).format(formate) : 
                moment(row[dIndexName]).format('lll') : 
                    "-" : (dIndexName && row[dIndexName]) ? 
                    formate ? dIndexName2 ?
                    row[dIndexName][dIndexName2] ?
                        moment(row[dIndexName][dIndexName2]).format(formate) : 
                    "-" :
                        moment(row[dIndexName]).format(formate) : 
                            moment(row[dIndexName]).format('lll') : 
                            "-"
);
